import { Reducer } from "redux";

import { DocumentReviewResponse } from "../models/api/Referral";
import { DocumentReviewActionDispatchTypes } from "../constants/Referral";
import { DocumentReviewDispatchTypes } from "../models/dispatchTypes/Referral";

const initialState: DocumentReviewResponse = {
  loading: false,
  response: {
    totalRows: 0,
    blobDocumentList: [
    ],
  },

  error: null,
};

const DocumentReviewReducer: Reducer<
  DocumentReviewResponse,
  DocumentReviewDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DocumentReviewActionDispatchTypes.DOCUMENT_REVIEW_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DocumentReviewActionDispatchTypes.DOCUMENT_REVIEW_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DocumentReviewActionDispatchTypes.DOCUMENT_REVIEW_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case DocumentReviewActionDispatchTypes.DOCUMENT_REVIEW_RESET: {
      return initialState;
    }
  }
  return state;
};

export default DocumentReviewReducer;